<template>
  <div class="row">
    <div class="col-12 text-center">
      <h1 style="font-size: 11em;">404</h1>
      <p class="h2">抱歉，您訪問的頁面不存在。</p>
      <br>
      <p>
        <button class="btn btn-primary" @click="$router.go(-1)">
          <i class="fas fa-arrow-left"></i> 回上一頁
        </button>
        <button class="btn btn-cathay" @click="$router.push({name:$conf.Index})">
          <i class="fa fa-home"></i> 回首頁
        </button>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    toHome() {},
    backTo() {}
  }
};
</script>

